import styled, { css } from 'styled-components'

import {
  _L_Normal,
  _S_Normal,
  DefaultLink,
  desktopMediaQuery,
  ellipsis,
  mainColors,
} from '@avantstay/backoffice-core'

const SharedDetailStyles = css`
  display: grid;
  gap: 20px;
  flex: 1;
`

export const BookingDetail = styled.div`
  ${SharedDetailStyles};
  grid-template-columns: 1fr 1.5fr;
`

export const BookingDetailMobile = styled(DefaultLink)`
  ${SharedDetailStyles};
  grid-template-columns: repeat(2, 1fr);

  &:hover {
    text-decoration: none;
  }
`

const SharedColumnStyles = css`
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
  overflow: auto;

  ${desktopMediaQuery`
    margin-bottom: 0;
  `}
`

export const BookingDetailColumn = styled.span`
  ${SharedColumnStyles};
  align-items: flex-start;
`

export const BookingPaymentColumn = styled.span`
  ${SharedColumnStyles};
  align-items: flex-end;
`

export const DetailTitle = styled.h3`
  ${_L_Normal};
  color: ${mainColors.black};
  margin-bottom: 2px;
  ${ellipsis};
`

export const DetailSubtitle = styled.h5`
  ${_S_Normal};
  color: ${mainColors.neutralExtremelyDark};
  ${ellipsis};
`
